import React from 'react';
import styles from './index.module.scss'

const Loading = (props) => {
  const {compData} = props;

  return (
    <div className={styles.wrapper}>
      <div>
        <div className={styles.loader}></div>
        <img src="https://www.theindianthing.com/shiva-statue/wp-content/uploads/2023/06/logo.webp" loading="lazy"/>
      </div>
    </div>
  );
};

export default Loading;
